import {
  HWCG_COMPANY_OPTIONS,
  type HwcgCompany,
} from './hwcgIncidentSpecifics';

/** Fallback when the responsible party has no roster of their own on file. */
export const HWCG_SOURCE_CONTROL_TEMPLATE_SLUG = 'hwcg-source-control';

const COMPANY_TO_SLUG: Record<HwcgCompany, string> = {
  'Meridian Offshore Energy': 'hwcg-rp-meridian-offshore-energy',
  'Gulfstar Deepwater': 'hwcg-rp-gulfstar-deepwater',
  'Pelican Point E&P': 'hwcg-rp-pelican-point-ep',
  'Ironclad Exploration Co.': 'hwcg-rp-ironclad-exploration',
  'Blue Horizon Petroleum': 'hwcg-rp-blue-horizon-petroleum',
};

export const HWCG_RESPONSIBLE_PARTY_TEMPLATE_SLUGS =
  Object.values(COMPANY_TO_SLUG);

export function hwcgResponsiblePartyTemplateSlug(
  companyName: string | null | undefined
): string | null {
  const key = companyName?.trim();
  if (!key) return null;
  const match = HWCG_COMPANY_OPTIONS.find(
    (company) => company.toLowerCase() === key.toLowerCase()
  );
  return match ? COMPANY_TO_SLUG[match] : null;
}

/**
 * Slug the Build Team step should load for a responsible party, falling back to
 * the generic HWCG Source Control chart for anyone without their own roster.
 */
/**
 * Seat names on the HWCG roster, in chart order. The source-control chart is
 * the full roster; a responsible-party chart is the same shape when that one is
 * the only HWCG template loaded.
 */
export function hwcgRosterPositionNames(
  templates: readonly {
    slug: string;
    nodes?: readonly { name: string }[] | null;
  }[]
): string[] {
  const source =
    templates.find(
      (template) => template.slug === HWCG_SOURCE_CONTROL_TEMPLATE_SLUG
    ) ??
    templates.find((template) => template.slug.startsWith('hwcg-rp-')) ??
    templates.find((template) => template.slug.startsWith('hwcg-'));
  const names: string[] = [];
  const seen = new Set<string>();
  for (const node of source?.nodes ?? []) {
    const name = node.name.trim();
    if (!name || seen.has(name)) continue;
    seen.add(name);
    names.push(name);
  }
  return names;
}

export function hwcgRosterTemplateSlug(
  companyName: string | null | undefined,
  knownSlugs: readonly string[]
): string | null {
  const preferred = hwcgResponsiblePartyTemplateSlug(companyName);
  if (preferred && knownSlugs.includes(preferred)) return preferred;
  if (knownSlugs.includes(HWCG_SOURCE_CONTROL_TEMPLATE_SLUG)) {
    return HWCG_SOURCE_CONTROL_TEMPLATE_SLUG;
  }
  return null;
}
